export default __webpack_public_path__ + "static/media/VolvoNovum-Regular.bf50112e.woff2";